/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_HelpInputs */



/**
* | output |
* | --- |
* | "Default text background used in the Closed Caption Preview." |
*
* @param {Options_Display_Default_Background_Color_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_help = /** @type {((inputs?: Options_Display_Default_Background_Color_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fond de texte par défaut utilisé dans l’aperçu des sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmäßiger Texthintergrund in der Untertitelvorschau.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sfondo del testo predefinito usato nell’anteprima dei sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фон текста по умолчанию, используемый в предварительном просмотре субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fondo de texto predeterminado usado en la vista previa de subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏式字幕预览中使用的默认文字背景。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕プレビューで使用されるデフォルトのテキスト背景です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज़्ड कैप्शन प्रीव्यू में उपयोग होने वाली डिफ़ॉल्ट टेक्स्ट पृष्ठभूमि।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo de texto predefinido utilizado na pré-visualização de legendas.")
	return /** @type {LocalizedString} */ ("Default text background used in the Closed Caption Preview.")
});